// import
import Dashboard from "views/Dashboard/Dashboard";
import UserManagement from "views/Dashboard/UserManagement";
import PackageManagement from "views/Dashboard/PackageManagement";
import SignIn from "views/Auth/SignIn.js";
import SignUp from "views/Auth/SignUp.js";
import {
  LayoutDashboard,
  ContactRound,
  PackageOpen,
  Vault,
  HandCoins,
  MessagesSquare,
  BellDot,
  Star,
  ChartNoAxesCombined,
  HeartHandshake,
  Truck,
  Ruler,
  Coins,
  Car,
  CarIcon,
  CarTaxiFront,
  PiggyBank,
  HouseIcon,
  Factory,
  UserCircle,
  BanknoteIcon,
  CaseLower,
  PiggyBankIcon,
  Percent,
  Gift,
  Store,
  Package,
  Headset,
  Bell,
  ShoppingBag,
  LucideShoppingBag,
  CommandIcon,
  Building2Icon,
  LucidePiggyBank,
  Handshake,
  UsersRound,
  BookOpen,
  BookOpenText,
  GraduationCap,
  HelpCircleIcon,
  MessageCircleQuestion
} from "lucide-react";
import Chat from "views/Dashboard/Chat";
import SmartLockerManagementPage from "views/Dashboard/SmartLockerManagement";
import TransactionManagement from "views/Dashboard/TransactionManagement";
import NotificationManagement from "views/Dashboard/Notifications";
import RatingManagement from "views/Dashboard/RatingReviewManagement";
import CompartmentPage from "views/Dashboard/SmartLockerManagement/components/CompartmentPage";
import Reports from "views/Dashboard/ReportsAnalytics";
import SupportHelpDesk from "views/Dashboard/Support";
import DeiliveryManagement from "views/Dashboard/DeliveryManagement";
import SizeEstimates from "views/Dashboard/SizeEstimatesManagement";
import DriverCommissionsManagement from "views/Dashboard/DriverCommissionsManagement";
import VehicleManagement from "views/Dashboard/VehicleManagement";
import { FaIndustry } from "react-icons/fa";
import BusinessManagement from "views/Dashboard/BusinessManagement";
import PasswordChange from "views/Auth/PasswordChange";
import Profile from "views/Dashboard/Profile";
import CommissionManagement from "views/Dashboard/DriverCommissionsManagement";
import { ProfileIcon } from "components/Icons/Icons";
import DriverManagement from "views/Dashboard/DriverManagement";
import VerifyOtp from "views/Auth/VerifyOtp.js";
import ManageBankDetailsTab from "views/Dashboard/BankDetailsManagement";
import KilometerManagement from "views/Dashboard/PackagePlanManagement";
import KilometerRatesManagement from "views/Dashboard/KilometerRatesManagement";
import PackageAndRatesTabs from "views/Dashboard/PackagePlansTabs";
import PaymentProofsTable from "views/Dashboard/PaymentProofs";
import ManageCompanySettingsTab from "views/Dashboard/CompanySettingsManagement";
import CompanyBankTabs from "views/Dashboard/CompanyBankTabs";
import ManageClaimsTab from "views/Dashboard/ClaimsManagement";
import LoyaltyReferralManagement from "views/Dashboard/LoyaltyReferralManagement";
import MerchantManagement from "views/Dashboard/MerchantManagement";
import ProductManagement from "views/Dashboard/ProductManagement";
import MerchantDashboard from "merchantViews/Dashboard";
import ProductListingManagement from "merchantViews/ProductListingManagement";
import ContactLogManagement from "views/Dashboard/ContactLogManagement";
import Communications from "views/Dashboard/Communications";
import PackageTabs from "views/Dashboard/Packages";
import DriverTabs from "views/Dashboard/Drivers";
import OrderManagement from "merchantViews/OrderManagement";
import ListingTabs from "merchantViews/ProductListingManagement/ListingTab";
import PartnersManagement from "views/Dashboard/PartnerManagement";
import PartnerPlanManagement from "views/Dashboard/PartnerPlanManagement";
import DriverPartners from "views/Dashboard/DriverPartnersManagement";
import DriverPartnerOperations from "views/Dashboard/DriverPartnerOperations";
import WalletTransactions from "views/Dashboard/WalletTransactions";
import AgentManagement from "views/Dashboard/AgentManagement";
import AgentTabs from "views/Dashboard/AgentOperations";
import AgentTraining from "views/Dashboard/TrainingManagement";
import AgentTrainingTabs from "views/Dashboard/AgentTrainingAndCertification";
import AgentSupportTab from "views/Dashboard/AgentSupport";



const dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <LayoutDashboard />,
    component: Dashboard,
    layout: "/admin",
  },
  // {
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   icon: <LayoutDashboard />,
  //   component: MerchantDashboard,
  //   layout: "/merchant",
  // },
  {
    path: "/user-management",
    name: "User Management",
    icon: <ContactRound />,
    component: UserManagement,
    layout: "/admin",
  },
  {
    path: "/package-management",
    name: "Package Management",
    icon: <PackageOpen />,
    component: PackageTabs,
    layout: "/admin",
  },
  {
    path: "/delivery-management",
    name: "Delivery Management",
    icon: <Truck />,
    component: DeiliveryManagement,
    layout: "/admin",
  },
  {
    path: "/driver-management",
    name: "Driver Operations",
    icon: <UserCircle />,
    component: DriverTabs,
    layout: "/admin",
  },
    {
    path: "/driver-partners",
    name: "Driver Partner Ops",
    icon: <Handshake />,
    component: DriverPartnerOperations,
    layout: "/admin",
  },
  {
    path: "/business-management",
    name: "Business Management",
    icon: <Factory />,
    component: BusinessManagement,
    layout: "/admin",
  },
  // {
  //   path: "/merchant-management",
  //   name: "Merchant Management",
  //   icon: <Store />,
  //   component: MerchantManagement,
  //   layout: "/admin",
  // },
  // {
  //   path: "/product-management",
  //   name: "Product Management",
  //   icon: <Package />,
  //   component: ProductManagement,
  //   layout: "/admin",
  // },
  // {
  //   path: "/product-management",
  //   name: "Product Management",
  //   icon: <Package />,
  //   component: ListingTabs,
  //   layout: "/merchant",
  // },
  // {
  //   path: "/order-management",
  //   name: "Order Management",
  //   icon: <LucideShoppingBag />,
  //   component: OrderManagement,
  //   layout: "/merchant",
  // },
  // {
  //   path: "/order-management",
  //   name: "Orders",
  //   icon: <LucideShoppingBag />,
  //   component: OrderManagement,
  //   layout: "/admin",
  // },

  {
    path: "/transactions",
    name: "Transactions",
    icon: <HandCoins />,
    component: WalletTransactions,
    layout: "/admin",
  },
  {
    path: "/company-settings",
    name: "Company Settings",
    icon: <Vault />,
    component: CompanyBankTabs,
    layout: "/admin",
  },
  {
    path: "/plan-management",
    name: "Package Plan Mgt",
    icon: <PiggyBankIcon />,
    component: PackageAndRatesTabs,
    layout: "/admin",
  },
    {
    path: "/agent-management",
    name: "Agent Management",
    icon: <UsersRound/>,
    component: AgentTabs,
    layout: "/admin",
  },
     {
    path: "/agent-support",
    name: "Agent Support",
    icon: <MessageCircleQuestion/>,
    component: AgentSupportTab,
    layout: "/admin",
  },
      {
    path: "/agent-training-management",
    name: "Agent Training & Cert.",
    icon: <GraduationCap/>,
    component: AgentTrainingTabs,
    layout: "/admin",
  },
  {
    path: "/loyalty-referral-management",
    name: "Loyalty & Referral Mgt",
    icon: <Gift />,
    component: LoyaltyReferralManagement,
    layout: "/admin",
  },
  // {
  //   path: "/notifications",
  //   name: "Notification Mgt.",
  //   icon: <BellDot />,
  //   component: NotificationManagement,
  //   layout: "/admin",
  // },
  {
    path: "/communications",
    name: "Communications",
    icon: <MessagesSquare />,
    component: Communications,
    layout: "/admin",
  },
  {
    path: "/rating",
    name: "Rating & Review",
    icon: <Star />,
    component: RatingManagement,
    layout: "/admin",
  },
  {
    path: "/reports-analytics",
    name: "Reports & Analytics",
    icon: <ChartNoAxesCombined />,
    component: Reports,
    layout: "/admin",
  },
  {
    path: "/support",
    name: "Support & Help Desk",
    icon: <HeartHandshake />,
    component: SupportHelpDesk,
    layout: "/admin",
  },
  // {
  //   path: "/partner-management",
  //   name: "Partner Management",
  //   icon: <Building2Icon />,
  //   component: PartnersManagement,
  //   layout: "/admin",
  // },
  // {
  //   path: "/partner-plan-management",
  //   name: "Partner Plan Management",
  //   icon: <LucidePiggyBank />,
  //   component: PartnerPlanManagement,
  //   layout: "/admin",
  // },
  {
    path: "/compartments",
    name: "Compartments",
    component: CompartmentPage,
    layout: "/admin",
    visible: false,
  },

  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    layout: "/admin",
    visible: false,
  },

  {
    path: "/signin",
    name: "Sign In",
    component: SignIn,
    layout: "/auth",
    visible: false,
  },
  {
    path: "/change-password",
    name: "Change Password",
    component: PasswordChange,
    layout: "/auth",
    visible: false,
  },
  {
    path: "/verify-otp",
    name: "Verify OTP",
    component: VerifyOtp,
    layout: "/auth",
    visible: false,
  },
  {
    path: "/signup",
    name: "Sign Up",
    component: SignUp,
    layout: "/auth",
    visible: false,
  },
];
export default dashRoutes;
